/**
 *
 * FBSectionHeader
 *
 */

import React, {memo} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// icons
// import CustomIcons from 'components/CustomIcons';

// antd component
// import { Button } from 'antd';
import { useTranslation } from "react-i18next";

// components
import {
  FBExportButton
} from 'components/Communications';


function FBAnswersTabHeader({
  type,
  title,
  btnName,
  showExport,
  data,
  extraActoins,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-answer-tab-header', type, className);
  const { t } = useTranslation();
  return (
    <div className="tcf-fb-answer-tab-header__wrapper">
      {/* INFO: hide export action for appointments, because there is no need for it */}
      {(type == 'appointments' && !!showExport) && (
        <FBExportButton className={type} key="export-button" type={type} attachmentData={data} btnName={btnName} />
      )}
      <div {...rest} className={childClassNames}>
        <div className="header-wrapper">
          <div className={`header-title`}>{!!title && title || t("news.formAnswers")}</div>
        </div>
        <div className="header-actions">
          {type == 'appointments' && extraActoins?.map(extr => extr)}
          {type == 'forms' && !!showExport && (
            <FBExportButton key="export-button" type={type} attachmentData={data} btnName={btnName} />
          )}
        </div>
      </div>
    </div>
  );
}

FBAnswersTabHeader.defaultProps = {
  type: 'forms',
  showExport: true,
};
FBAnswersTabHeader.propTypes = {
  type: PropTypes.oneOf(['appointments', 'forms']).isRequired,
  csvData: PropTypes.oneOfType([PropTypes.bool, PropTypes.array])
};

export default memo(FBAnswersTabHeader);
